var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CA-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2295 8.52339L11.1818 8.66085C11.1586 8.72744 11.1421 8.77265 11.1391 8.78121C10.9118 9.3842 10.5049 9.86867 9.93004 10.2212C9.2293 10.6513 8.42958 10.7991 7.55411 10.6604C6.42083 10.4808 5.5753 9.85095 5.04195 8.78854C4.54037 7.79088 4.47867 6.72113 4.85684 5.60862C4.95825 5.30987 5.09021 5.03739 5.25028 4.79058C5.25639 4.78447 5.26189 4.77836 5.26739 4.77286C5.33581 4.66656 5.40912 4.56575 5.48793 4.46923C5.5197 4.43013 5.55208 4.39164 5.58568 4.35498H3.08085C3.08085 4.35498 3.07902 4.35926 3.07718 4.36109H0.483154L0.798396 5.19257C1.07148 5.91286 1.76123 6.38939 2.53101 6.39062C2.53101 6.39489 2.55056 6.39611 2.57622 6.3955C2.5194 7.01377 2.5585 7.64975 2.69229 8.29796C2.9495 9.53876 3.57876 10.5865 4.56298 11.4119C5.12993 11.8872 5.77018 12.2336 6.46543 12.4419C7.01344 12.6057 7.57733 12.6875 8.15283 12.6875C8.59454 12.6875 9.04419 12.6393 9.49689 12.5427C10.9485 12.233 12.0213 11.4125 12.7764 10.0355L12.8124 9.96947L11.2283 8.524L11.2295 8.52339Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.76499 3.13431H8.02952C8.54698 3.13431 9.07727 3.25405 9.60512 3.48926C10.312 3.80389 10.8105 4.32563 11.0872 5.0392L12.6274 3.61939C12.2095 2.94614 11.6475 2.40913 10.9528 2.02241C10.3187 1.66929 9.60756 1.44935 8.77852 1.35099C8.682 1.33938 8.40036 1.3125 7.85846 1.3125H0L0.26148 2.00225C0.502188 2.63762 1.0948 3.08177 1.76499 3.13492",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaShort);
export default __webpack_public_path__ + "static/media/CA-short.0e237e6dffe631894b056e3e48152f84.svg";
export { ForwardRef as ReactComponent };